// extracted by mini-css-extract-plugin
export var drawerContent = "_3r-0";
export var valueBlock = "_3r-1";
export var valueBlockFrom = "_3r-2 _3r-1";
export var valueBlockTo = "_3r-3 _3r-1";